import CountryOfOriginIcon from './CountryOfOriginIcon';

export default CountryOfOriginIcon;
